import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { gateway } from 'libs/generated-grpc-web';

@Component({
  selector: 'mg-basic-notification',
  templateUrl: './MgBasicNotification.element.html',
  styleUrls: ['./MgBasicNotification.element.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MgBasicNotificationElement {
  @Input()
  notification?: gateway.notification_pb.Notification.AsObject;
}
